var jQuery_dev_one = jQuery;
jQuery_dev_one(window).ready(function () {
  console.log("I am ready");
  jQuery_dev_one(document).on(
    "click",
    ".sdev-product-variation-check",
    function (eve) {
      console.log(eve.target);
      let element = jQuery_dev_one(eve.target);
      let variantId = element.data("variant-id"),
        variantSection = element.data("collection"),
        productId = element.data("product-id"),
        section = jQuery_dev_one("." + variantSection + "-product-lists"),
        productItem = jQuery_dev_one(
          '.item[data-product-id="' + productId + '"]'
        ),
        tabSection = jQuery_dev_one("." + variantSection + "-variation-tabs");
      element
        .closest(".dev-variant-check")
        .find(".sdev-product-variation-check")
        .removeClass("active");
      element.addClass("active");
      let sizeVal = element.data("option-value"),
        planVal;
      if (
        element.closest(".dev-variant-check").next(".dev-variant-plan") &&
        element.closest(".dev-variant-check").next(".dev-variant-plan").length >
          0
      ) {
        planVal = element
          .closest(".dev-variant-check")
          .next(".dev-variant-plan")
          .find("select")
          .val();
      }
      console.log("sizeVal : " + sizeVal);
      console.log("planVal : " + planVal);
      console.log(productItem);
      if (productItem && productItem.length > 0) {
        //   console.log( productItem );
        productItem.find(".sdev-product-variant-details").addClass("hide");
        if (sizeVal && sizeVal != "" && planVal && planVal != "") {
          productItem
            .find(
              '.sdev-product-variant-details[data-variant-one="' +
                sizeVal +
                '"][data-variant-two="' +
                planVal +
                '"]'
            )
            .removeClass("hide");
        } else if (sizeVal && sizeVal != "") {
          productItem
            .find(
              '.sdev-product-variant-details[data-variant-one="' +
                sizeVal +
                '"]'
            )
            .removeClass("hide");
        }
        //  console.log( '.sdev-product-variant-details[data-variant-id="'+variantId+'"]' );
      }
    }
  );
  jQuery_dev_one(document).on("change", "select.variantbtnone", function (eve) {
    let element = jQuery_dev_one(eve.target);
      let sizeVal, activityVal, planVal;
      const {optionName, productId} = element.data();
       let productItem = jQuery_dev_one('.item[data-product-id="' + productId + '"]');
      if(optionName == 'plan'){
        activityVal = $(`[data-product-id="${productId}"][data-option-name="activity"]`).val();
        planVal = element.val();
      }else{
        planVal = $(`[data-product-id="${productId}"][data-option-name="plan"]`).val();
        activityVal = element.val();
      }
        sizeVal = productItem
          .find(".sdev-product-variation-check.active")
          .data("option-value");
      if(activityVal && activityVal != "" && sizeVal && sizeVal != ""  && planVal && planVal != ""){
        productItem.find(".sdev-product-variant-details").addClass("hide");
        $(`.sdev-product-variant-details[data-variant-one="${sizeVal}"][data-variant-two="${planVal}"][data-variant-three="${activityVal}"]`).removeClass('hide')
      }
  });

  


  jQuery_dev_one(document).on(
    "click",
    ".dev-product-add-to-variant",
    function (eve) {
      let elem = jQuery_dev_one(this),
        idEL = elem.data("variant-id");
      jQuery
        .post("/cart/add.js", {
          quantity: 1,
          id: idEL,
        })
        .then((res) => {
          	//return res.json();
          //history.go(0);
                //location.reload(true);
          //reloadCart();
          setTimeout(function() {
           jQuery.getJSON('/cart.js', function(cart) {
                let cartData = cart.items;
                document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
                document.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true,
                     detail: cartData
                })); 
           }).then(()=>{
             console.log( 'this istesin' );
             jQuery( '.t4s-site-nav__icon.t4s-site-nav__cart a' ).trigger( 'click' );
           });
           }, 400); 
        });
    }
  );

  function getGemProductAtcContext(target) {
    if (!target || !target.closest) return null;

    var button = target.closest(
      'button.gp-button-atc[type="submit"][name="add"]'
    );

    if (!button) return null;

    var wrapper = button.closest('gp-product-button[gp-data-wrapper]');
    var form = button.closest('form[data-type="add-to-cart-form"]');

    if (!wrapper || !form) return null;

    if ((wrapper.getAttribute("gp-data") || "").indexOf('"actionEffect":"buy-now"') !== -1) {
      return null;
    }

    return {
      button: button,
      form: form,
    };
  }

  function getShopifyRootUrl() {
    return (
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.T4Sroutes && window.T4Sroutes.root_url) ||
      "/"
    );
  }

  function updateMiniCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (node) {
      node.innerHTML = count;
    });

    document.documentElement.classList.toggle("t4s-cart-count-0", count === 0);

    document.dispatchEvent(
      new CustomEvent("cart:update:count", {
        detail: { count: count },
        bubbles: true,
        cancelable: true,
      })
    );
  }

  function isMiniCartInteractiveReady() {
    var drawer = document.querySelector("#t4s-mini_cart");

    return !!(
      drawer &&
      drawer.querySelector("[data-cart-items]") &&
      drawer.querySelector("[data-cart-prices]")
    );
  }

  function replaceMiniCartMarkup(sectionHtml) {
    var temp = document.createElement("div");
    var currentDrawer = document.querySelector("#t4s-mini_cart");
    var sectionRoot;

    if (!sectionHtml) return currentDrawer;

    temp.innerHTML = sectionHtml;

    var nextDrawer = temp.querySelector("#t4s-mini_cart");

    if (nextDrawer && currentDrawer) {
      currentDrawer.replaceWith(nextDrawer);
      return nextDrawer;
    }

    if (nextDrawer && !currentDrawer) {
      document.body.appendChild(nextDrawer);
      return nextDrawer;
    }

    sectionRoot = temp.querySelector("#shopify-section-mini_cart");

    if (currentDrawer) {
      currentDrawer.innerHTML = sectionRoot ? sectionRoot.innerHTML : sectionHtml;
    }

    return currentDrawer;
  }

  function parseCartDataSummary(cartDataHtml) {
    var parts;

    if (!cartDataHtml || typeof cartDataHtml !== "string") return null;

    parts = cartDataHtml.split("[t4s_split1]");
    if (parts.length < 2) return null;

    parts = parts[1].split("[t4s_split2]");

    return {
      count: parseInt(parts[0], 10) || 0,
      totalPriceHtml: parts[1] || "",
    };
  }

  function applySectionsToMiniCart(sections) {
    var drawer;
    var sectionHtml;
    var summary;

    if (!sections) return null;

    sectionHtml =
      sections.mini_cart ||
      (window.cartT4SectionID && sections[window.cartT4SectionID]) ||
      "";

    summary = parseCartDataSummary(sections.cart_data);
    drawer = replaceMiniCartMarkup(sectionHtml);

    if (summary) {
      updateMiniCartCount(summary.count);

      document.querySelectorAll("[data-cart-tt-price]").forEach(function (node) {
        node.innerHTML = summary.totalPriceHtml;
      });

      if (drawer) {
        drawer.setAttribute("data-ccount", String(summary.count));
      }
    }

    return drawer;
  }

  function openMiniCartDrawer(drawer) {
    if (!drawer) return;

    if (
      window.T4SThemeSP &&
      window.T4SThemeSP.Drawer &&
      typeof window.T4SThemeSP.Drawer.opend === "function"
    ) {
      window.T4SThemeSP.Drawer.opend(jQuery_dev_one(drawer));
      return;
    }

    drawer.setAttribute("aria-hidden", "false");

    var overlay = document.querySelector(".t4s-close-overlay");
    if (overlay) {
      overlay.classList.add("is--visible");
    }

    document.body.classList.add("t4s-lock-scroll", "is--opend-drawer");
  }

  function refreshGemProductCartDrawer(sections) {
    var rootUrl = getShopifyRootUrl();

    if (sections) {
      if (
        isMiniCartInteractiveReady() &&
        window.T4SThemeSP &&
        window.T4SThemeSP.Cart &&
        typeof window.T4SThemeSP.Cart.renderContents === "function"
      ) {
        window.T4SThemeSP.Cart.renderContents(sections, true);
        scheduleMiniCartCheckoutEnable();
        return Promise.resolve();
      }

      var updatedDrawer = applySectionsToMiniCart(sections);

      if (
        window.T4SThemeSP &&
        window.T4SThemeSP.ProductAjax &&
        typeof window.T4SThemeSP.ProductAjax.change === "function"
      ) {
        window.T4SThemeSP.ProductAjax.change();
      }

      if (
        window.T4SThemeSP &&
        typeof window.T4SThemeSP.agreeForm === "function"
      ) {
        window.T4SThemeSP.agreeForm();
      }

      if (
        window.T4SThemeSP &&
        typeof window.T4SThemeSP.Tooltip === "function"
      ) {
        window.T4SThemeSP.Tooltip();
      }

      if (
        !window.__mindorMiniCartHydrated &&
        window.T4SThemeSP &&
        typeof window.T4SThemeSP.T4sQuantityAdjust === "function"
      ) {
        window.__mindorMiniCartHydrated = true;
        window.T4SThemeSP.T4sQuantityAdjust();
      }

      scheduleMiniCartCheckoutEnable();

      jQuery_dev_one(document).trigger("cart:updated");
      openMiniCartDrawer(updatedDrawer);
      return Promise.resolve();
    }

    return Promise.all([
      fetch(rootUrl + "cart.js", {
        cache: "no-store",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then(function (response) {
        return response.json();
      }),
      fetch(rootUrl + "?section_id=mini_cart&_=" + Date.now(), {
        cache: "no-store",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then(function (response) {
        return response.text();
      }),
    ])
      .then(function (results) {
        var cart = results[0] || {};
        var sectionHtml = results[1] || "";
        var drawer = replaceMiniCartMarkup(sectionHtml);
        var totalPriceNode = drawer && drawer.querySelector(".t4s-cart__totalPrice");

        updateMiniCartCount(cart.item_count || 0);

        if (totalPriceNode) {
          document.querySelectorAll("[data-cart-tt-price]").forEach(function (node) {
            node.innerHTML = totalPriceNode.innerHTML;
          });
        }

        if (
          window.T4SThemeSP &&
          window.T4SThemeSP.ProductAjax &&
          typeof window.T4SThemeSP.ProductAjax.change === "function"
        ) {
          window.T4SThemeSP.ProductAjax.change();
        }

        if (
          window.T4SThemeSP &&
          typeof window.T4SThemeSP.agreeForm === "function"
        ) {
          window.T4SThemeSP.agreeForm();
        }

        if (
          window.T4SThemeSP &&
          typeof window.T4SThemeSP.Tooltip === "function"
        ) {
          window.T4SThemeSP.Tooltip();
        }

        scheduleMiniCartCheckoutEnable();

        jQuery_dev_one(document).trigger("cart:updated");
        openMiniCartDrawer(drawer);
      })
      .catch(function () {
        if (
          window.T4SThemeSP &&
          window.T4SThemeSP.Cart &&
          typeof window.T4SThemeSP.Cart.getToFetch === "function"
        ) {
          window.T4SThemeSP.Cart.getToFetch(true);
          return;
        }

        document.dispatchEvent(
          new CustomEvent("cart:refresh:opend", { bubbles: true })
        );
      });
  }

  function showGemProductAtcError(error) {
    var message =
      (error && (error.description || error.message)) ||
      "Cannot add product to cart";

    if (
      window.T4SThemeSP &&
      typeof window.T4SThemeSP.Notices === "function"
    ) {
      window.T4SThemeSP.Notices(message);
      return;
    }

    window.alert(message);
  }

  function requestJson(url, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();

      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.setRequestHeader("Accept", "application/json");
      xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

      xhr.onreadystatechange = function () {
        var data = {};

        if (xhr.readyState !== 4) return;

        try {
          data = JSON.parse(xhr.responseText || "{}");
        } catch (error) {}

        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(data);
        } else {
          reject(data);
        }
      };

      xhr.onerror = function () {
        reject({ message: "Request failed" });
      };

      xhr.send(JSON.stringify(body));
    });
  }

  function setButtonLoading(button, loading) {
    var spinnerWrap;
    var spinnerIcon;

    if (!button) return;

    spinnerWrap = button.querySelector(".t4s-loading__spinner");
    spinnerIcon = button.querySelector(".t4s-svg-spinner");

    button.classList.toggle("is--loading", !!loading);

    if (spinnerWrap) {
      if (loading) {
        spinnerWrap.removeAttribute("hidden");
      } else {
        spinnerWrap.setAttribute("hidden", "");
      }
    }

    if (spinnerIcon) {
      if (loading) {
        spinnerIcon.removeAttribute("hidden");
      } else {
        spinnerIcon.setAttribute("hidden", "");
      }
    }
  }

  function setMiniCartLoading(loading) {
    var drawer = document.querySelector("#t4s-mini_cart");

    if (!drawer) return;

    drawer.classList.toggle("is--contentUpdate", !!loading);
  }

  function setMiniCartItemLoading(triggerElement, loading) {
    var item;
    var drawer;
    var bar;
    var spinner;
    var check;

    if (!triggerElement || !triggerElement.closest) return;

    item = triggerElement.closest("[data-cart-item]");
    drawer = document.querySelector("#t4s-mini_cart");
    bar = item && item.querySelector(".t4s-cart-ld__bar");
    spinner = bar && bar.querySelector(".t4s-cart-spinner");
    check = bar && bar.querySelector(".t4s-cart-check");

    if (drawer) {
      drawer.classList.toggle("is--contentUpdate", !!loading);
    }

    if (item) {
      item.classList.toggle("is--update", !!loading);
    }

    if (bar) {
      if (loading) {
        bar.removeAttribute("hidden");
      } else {
        bar.setAttribute("hidden", "");
      }
    }

    if (spinner) {
      if (loading) {
        spinner.removeAttribute("hidden");
      } else {
        spinner.setAttribute("hidden", "");
      }
    }

    if (check) {
      check.setAttribute("hidden", "");
    }
  }

  function showAgreeCheckoutNotice() {
    if (
      window.T4SThemeSP &&
      typeof window.T4SThemeSP.Notices === "function" &&
      window.T4Sstrings &&
      window.T4Sstrings.agree_checkout
    ) {
      window.T4SThemeSP.Notices(window.T4Sstrings.agree_checkout);
      return;
    }

    window.alert("Please agree to the terms and conditions to continue.");
  }

  var miniCartCheckoutTimer = 0;

  function enableMiniCartCheckoutButtons() {
    document
      .querySelectorAll('#t4s-mini_cart .t4s-btn__checkout')
      .forEach(function (button) {
        button.disabled = false;
        button.removeAttribute("disabled");
        button.removeAttribute("data-pickeasy-key");
        button.removeAttribute("name");
        button.setAttribute("type", "button");
        button.setAttribute("data-mini-cart-checkout", "");
        button.classList.remove("t4s-loading", "is--loading", "is-loading");
      });
  }

  function watchMiniCartCheckoutButtons() {
    if (miniCartCheckoutTimer) {
      window.clearInterval(miniCartCheckoutTimer);
      miniCartCheckoutTimer = 0;
    }

    miniCartCheckoutTimer = window.setInterval(function () {
      enableMiniCartCheckoutButtons();
    }, 250);

    window.setTimeout(function () {
      if (miniCartCheckoutTimer) {
        window.clearInterval(miniCartCheckoutTimer);
        miniCartCheckoutTimer = 0;
      }
    }, 5000);
  }

  function scheduleMiniCartCheckoutEnable() {
    enableMiniCartCheckoutButtons();
    watchMiniCartCheckoutButtons();
    setTimeout(enableMiniCartCheckoutButtons, 120);
    setTimeout(enableMiniCartCheckoutButtons, 400);
    setTimeout(enableMiniCartCheckoutButtons, 1000);
    setTimeout(enableMiniCartCheckoutButtons, 2000);
  }

  function getMiniCartCheckoutContext(target) {
    var button = target && target.closest
      ? target.closest('#t4s-mini_cart [data-mini-cart-checkout], #t4s-mini_cart .t4s-btn__checkout')
      : null;

    if (!button) return null;

    return {
      button: button,
      form: button.closest("form"),
    };
  }

  function proceedMiniCartCheckout(context) {
    var checkbox;
    var rootUrl;

    if (!context || !context.form) return;

    checkbox = context.form.querySelector("[data-agree-checkbox]");
    if (checkbox && !checkbox.checked) {
      showAgreeCheckoutNotice();
      return;
    }

    rootUrl = getShopifyRootUrl();
    window.location.href = rootUrl + "checkout";
  }

  var miniCartChangeInFlight = false;

  function changeMiniCartLine(id, quantity, triggerElement) {
    var rootUrl = getShopifyRootUrl();

    if (miniCartChangeInFlight || !id) return;
    miniCartChangeInFlight = true;
    document.documentElement.classList.add("mindor-cart-busy");
    setMiniCartItemLoading(triggerElement, true);

    requestJson(rootUrl + "cart/change.js", {
      id: String(id),
      quantity: quantity,
      sections: "cart_data,mini_cart",
      sections_url: window.location.pathname,
    })
      .then(function (response) {
        return refreshGemProductCartDrawer(response.sections);
      })
      .catch(function (error) {
        showGemProductAtcError(error);
      })
      .finally(function () {
        miniCartChangeInFlight = false;
        document.documentElement.classList.remove("mindor-cart-busy");
        setMiniCartItemLoading(triggerElement, false);
      });
  }

  function intVal(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function getStandardProductAtcContext(event) {
    var form = event.target;

    if (!form || !form.matches) return null;

    if (
      !form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')
    ) {
      return null;
    }

    var submitter = event.submitter;

    if (!submitter || submitter.form !== form || submitter.type !== "submit") {
      submitter = form.querySelector('[name="add"][type="submit"]');
    }

    if (!submitter || submitter.form !== form) {
      submitter = document.activeElement;
    }

    var wrapper =
      submitter && submitter.closest
        ? submitter.closest('gp-product-button[gp-data-wrapper]')
        : null;

    if (
      wrapper &&
      (wrapper.getAttribute("gp-data") || "").indexOf('"actionEffect":"buy-now"') !== -1
    ) {
      return null;
    }

    if (submitter && submitter.closest && submitter.closest(".shopify-payment-button")) {
      return null;
    }

    if (submitter && submitter.name && submitter.name !== "add") {
      return null;
    }

    if (!submitter || submitter.form !== form) {
      submitter = form.querySelector('[name="add"]');
    }

    return {
      button: submitter,
      form: form,
    };
  }

  function submitGemProductAtc(button, form) {
    if (button && button.dataset.gpAjaxAtc === "true") return;

    var previousState = button ? button.getAttribute("data-state") || "idle" : "idle";
    var previousAriaDisabled = button ? button.getAttribute("aria-disabled") : null;
    var wasDisabled = button ? button.hasAttribute("disabled") : false;
    var formData = new FormData(form);
    var rootUrl = getShopifyRootUrl();
    var variantId = formData.get("id");

    if (!variantId) {
      if (
        window.T4SThemeSP &&
        typeof window.T4SThemeSP.Notices === "function" &&
        window.T4SProductStrings &&
        window.T4SProductStrings.pleaseChooseOptions
      ) {
        window.T4SThemeSP.Notices(window.T4SProductStrings.pleaseChooseOptions);
      }
      return;
    }

    if (!formData.get("quantity")) {
      formData.set("quantity", "1");
    }

    formData.set("sections", "cart_data,mini_cart");
    formData.set("sections_url", window.location.pathname);

    if (button) {
      button.dataset.gpAjaxAtc = "true";
      button.setAttribute("data-state", "loading");
      button.setAttribute("aria-disabled", "true");
      button.setAttribute("disabled", "disabled");
      setButtonLoading(button, true);
    }

    setMiniCartLoading(true);

    fetch(rootUrl + "cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw data;
          }

          return data;
        });
      })
      .then(function (data) {
        jQuery_dev_one(document)
          .trigger("add:cart:success")
          .trigger("add:cart:upsell");

        return refreshGemProductCartDrawer(data.sections);
      })
      .catch(function (error) {
        showGemProductAtcError(error);
      })
      .finally(function () {
        if (!button) return;

        delete button.dataset.gpAjaxAtc;
        button.setAttribute("data-state", previousState);
        setButtonLoading(button, false);

        if (previousAriaDisabled === null) {
          button.removeAttribute("aria-disabled");
        } else {
          button.setAttribute("aria-disabled", previousAriaDisabled);
        }

        if (wasDisabled) {
          button.setAttribute("disabled", "disabled");
        } else {
          button.removeAttribute("disabled");
        }

        setMiniCartLoading(false);
      });
  }

  document.addEventListener(
    "click",
    function (event) {
      var context = getGemProductAtcContext(event.target);

      if (!context) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      submitGemProductAtc(context.button, context.form);
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      var context = getGemProductAtcContext(
        event.submitter ||
          event.target.querySelector('button.gp-button-atc[type="submit"][name="add"]')
      );

      if (!context) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      submitGemProductAtc(context.button, context.form);
    },
    true
  );

  document.addEventListener("submit", function (event) {
    var context;

    if (event.defaultPrevented) return;

    context = getStandardProductAtcContext(event);

    if (!context) return;

    event.preventDefault();
    submitGemProductAtc(context.button, context.form);
  });

  document.addEventListener(
    "pointerdown",
    function (event) {
      var checkoutContext = getMiniCartCheckoutContext(event.target);

      if (!checkoutContext) return;

      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    "click",
    function (event) {
      var removeBtn;
      var stepBtn;
      var wrapper;
      var input;
      var id;
      var min;
      var max;
      var current;
      var next;
      var checkoutContext = getMiniCartCheckoutContext(event.target);

      if (checkoutContext) {
        event.preventDefault();
        event.stopImmediatePropagation();
        proceedMiniCartCheckout(checkoutContext);
        return;
      }

      removeBtn = event.target.closest
        ? event.target.closest('#t4s-mini_cart [data-cart-remove]')
        : null;

      if (removeBtn && removeBtn.closest("[data-cart-item]")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        changeMiniCartLine(removeBtn.getAttribute("data-id"), 0, removeBtn);
        return;
      }

      stepBtn = event.target.closest
        ? event.target.closest('#t4s-mini_cart [data-quantity-selector]')
        : null;

      if (!stepBtn || !stepBtn.closest("[data-cart-item]")) return;

      wrapper = stepBtn.closest("[data-quantity-wrapper]");
      input = wrapper && wrapper.querySelector("[data-quantity-value][data-id]");
      if (!input) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      id = input.getAttribute("data-id");
      min = intVal(input.getAttribute("min"), 1);
      max = intVal(input.getAttribute("max"), 999999);
      current = intVal(input.value, 1);
      next = current;

      if (stepBtn.hasAttribute("data-increase-qty")) {
        next = Math.min(max, current + 1);
      } else if (stepBtn.hasAttribute("data-decrease-qty")) {
        next = current - 1;
        if (next < min) next = 0;
      }

      if (next !== current) {
        changeMiniCartLine(id, next, stepBtn);
      }
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      var checkoutContext = getMiniCartCheckoutContext(event.submitter || event.target);

      if (!checkoutContext) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      proceedMiniCartCheckout(checkoutContext);
    },
    true
  );

  jQuery_dev_one(document)
    .off("cart:updated.mindorCheckout")
    .on("cart:updated.mindorCheckout", function () {
      scheduleMiniCartCheckoutEnable();
    });


  if (jQuery_dev_one(".dev-variant-plan").length > 0) {
    jQuery_dev_one(".dev-variant-plan").each((key, obj) => {
      let valueE = "";
      jQuery_dev_one(obj)
        .find("select option")
        .each(function (elm, val) {
          if (elm == 1) {
            valueE = jQuery_dev_one(val).attr("value");
          }
        });
      jQuery_dev_one(obj).find("select").val(valueE);
    });
  }
});


// $(document).ready(function(){
// $('.t4s-btn__checkout').removeAttr('disabled');
// });
